module.exports = __webpack_public_path__ + "img/3.1a2bd58d.png";